'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import type { Address } from 'viem';
import { VaultDistributionTable } from '@/components/VaultPage/vaultDistribution/components/VaultDistributionTable';
import { columnsDefs } from './config';
export interface VaultV2TableDistributionClientProps {
  address: Address;
  chainId: ChainId;
}
const VaultV2TableDistributionClient = t0 => {
  const $ = _c(3);
  const {
    address,
    chainId
  } = t0;
  let t1;
  if ($[0] !== address || $[1] !== chainId) {
    t1 = <VaultDistributionTable address={address} chainId={chainId} vaultVersion="v2" columns={columnsDefs} scrollAreaClassName="rounded-[20px]" />;
    $[0] = address;
    $[1] = chainId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default VaultV2TableDistributionClient;